import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function Offer() {
  const {
    trackAddToCart
  } = useMetaPixel();
  const features = ['Planificaciones Primaria y Secundaria', 'Planificaciones Anuales completas (Bono 1 y 2)', 'Proyectos Anuales completos (Bono 3 y 4)', 'Actividades y recursos creativos editables', 'Evaluaciones con criterios claros', 'Acceso de por vida a las actualizaciones'];
  const handleAddToCart = () => {
    trackAddToCart(19990, 'ARS');
    window.location.href = 'https://checkout15.recursospro.shop/cart/44926459019455:1';
  };
  return <section id="comprar" className="w-full bg-gray-50 py-20 px-4" data-id="element-73">
      <div className="max-w-2xl mx-auto" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-3xl shadow-2xl overflow-hidden" data-id="element-75">
          {/* Hero Image */}
          <div className="relative" data-id="element-76">
            <img src="https://cdn.magicpatterns.com/uploads/19uHnUtnEQ2QnBtEybrBat/heylloyd-image-1771788686896.png" alt="Equipo de docentes trabajando con el Mega Pack" className="w-full h-48 md:h-64 object-cover" data-id="element-77" />
          </div>

          {/* Content */}
          <div className="p-8" data-id="element-78">
            {/* Badges */}
            <div className="flex flex-wrap items-center justify-between gap-4 mb-6" data-id="element-79">
              <div className="bg-red-50 text-red-700 px-6 py-3 rounded-full font-bold text-sm" data-id="element-80">
                OFERTA LIMITADA
              </div>
              <div className="flex items-center gap-2 text-green-600" data-id="element-81">
                <ShieldCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-82" />
                <span className="font-bold text-sm" data-id="element-83">
                  Garantía de Satisfacción
                </span>
              </div>
            </div>

            {/* Title */}
            <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4" data-id="element-84">
              Mega Pack de Arte
            </h2>

            {/* Description */}
            <p className="text-gray-600 mb-6 text-lg" data-id="element-85">
              Acceso inmediato a todos los recursos, planificaciones y bonos
              exclusivos.
            </p>

            {/* Pricing */}
            <div className="mb-8" data-id="element-86">
              <div className="flex items-center gap-4 mb-2" data-id="element-87">
                <span className="text-2xl text-gray-400 line-through font-bold" data-id="element-88">
                  $47.900
                </span>
                <span className="bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-bold" data-id="element-89">
                  -58% OFF
                </span>
              </div>
              <div className="text-6xl md:text-7xl font-black text-gray-900" data-id="element-90">
                $19.990
              </div>
            </div>

            {/* CTA Button */}
            <motion.button onClick={handleAddToCart} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="block w-full bg-red-700 text-white text-center px-8 py-5 rounded-xl font-bold text-xl shadow-xl hover:bg-red-800 transition-all duration-300 mb-4" data-id="element-91">
              Adquirir el Pack
            </motion.button>

            <p className="text-center text-sm text-gray-600 mb-8" data-id="element-92">
              Pago seguro con Mercado Pago
            </p>

            {/* Features List */}
            <div className="border-t border-gray-200 pt-8" data-id="element-93">
              <h4 className="text-xl font-bold text-gray-900 mb-6" data-id="element-94">
                Lo que recibís hoy:
              </h4>

              <ul className="space-y-4" role="list" data-id="element-95">
                {features.map((feature, index) => <motion.li key={index} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.1
              }} className="flex items-start" data-id="element-96">
                    <CheckIcon className="h-6 w-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-97" />
                    <span className="text-gray-700" data-id="element-98">{feature}</span>
                  </motion.li>)}
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}